module.exports = __webpack_public_path__ + "media/images/slide-19-8be5d99ce48645b97716ace8e4400f6c.jpg";